import React, { useEffect, useState } from 'react'

import {
    VerticalTimeline,
    VerticalTimelineElement,
  } from "react-vertical-timeline-component";
  import "react-vertical-timeline-component/style.min.css";
import { client } from '../../client';


import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
const Achievement = () => {

    const [achievements, setAchievement] = useState([]);

    useEffect(() => {
      const query = `*[_type == "achievementsection"]{
        achievementname,
        achievementshortdesc,
        "achievementdoclinks": achievementdoclink.asset->url,
        doach,
        id,
            
              
          } | order(id asc)`;
  
      client.fetch(query).then((data) => {
        setAchievement(data);
      });
    }, []);
    
    
  return (
    <VerticalTimeline layout="1-column-left">
    {achievements &&
      achievements.map((achdata, achkey) => (
        <a style={{textDecoration:'none', color:'white'}} href={achdata.achievementdoclinks} target='_blank'>
        <VerticalTimelineElement
          key={achkey}
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#29172d", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  #29172d" }}
          date={achdata.doach}
          iconStyle={{ background: "#29172d", color: "#fff" }}
          icon={<EmojiEventsIcon />}
          position="right"
        >
          <h3 className="vertical-timeline-element-title">
           {achdata.achievementname}
          </h3>
         
          <p>
            {achdata.achievementshortdesc}
          </p>
          <p>
            {/* {achdata.universityname}. */}
          </p>
        </VerticalTimelineElement>
        </a>
      ))}
  </VerticalTimeline>
  )
}

export default Achievement